import React, { useState } from "react";
import { RCCHookToast, RCCServicesApi } from "react-common-components";
import { standardErrorMessages } from "src/utils/errors";
import { getLocalStorage, setLocalStorage } from "src/utils/localStorage";
import { useConfirmModal } from "../ConfirmModal/context";
import { useTranslation } from "../Translations/context";
import { MaintenanceContext } from "./context";

const LS_PATH = "MaintenanceMode";

const MaintenanceProvider: React.FC = ({children}) => {
	const { addToast } = RCCHookToast();
	const { translate } = useTranslation();
	const { confirm } = useConfirmModal();
	const [isInMaintenance, setIsInMaintenance] = useState(getLocalStorage(LS_PATH) === "y");

	const toggleMaintenance = async () => {
		confirm(
			translate("Modo manutenção"),
			isInMaintenance ? `${translate("Deseja desativar o modo manutenção")} ?` : `${translate("Deseja ativar o modo manutenção")} ?`,
			async () => {
				const {data} = await RCCServicesApi.postRequest({
					method: "System/MaintenanceMode"
				});

				updateMaintenance(data);

				addToast({
					color: "green",
					description: data ? translate("Você ativou o modo manutenção") : translate("Você desativou o modo manuntenção"),
					title: translate("Sucesso")
				});
			},
			(err) => {
				standardErrorMessages(err, translate("Erro ao ativar/desativar modo manutenção"), addToast);
			},
			false
		);
	};

	const updateMaintenance = (data: boolean) => {
		setIsInMaintenance(data);
		setLocalStorage(LS_PATH, data ? "y" : "n");
	};

	return (
		<MaintenanceContext.Provider value={{
			toggleMaintenance,
			isInMaintenance,
			updateMaintenance
		}}>
			{children}
		</MaintenanceContext.Provider>
	);
};

export default MaintenanceProvider;
